import { connect } from "react-redux";
import { mapStateToProps } from "../../store/helpers/mapState";
import { mapDispatchToProps } from "../../store/helpers/mapDispatch";
import React, { useEffect, useState } from "react";
import DatatableComponent from "../../helpers/DatatableComponent";
import BasicMenu from "../../helpers/menu";
import NoteAltIcon from "@mui/icons-material/NoteAlt";
import FormDialog from "../../helpers/FormDialog";
import {
  Button,
  Card,
  CardContent,
  CardHeader,
  Checkbox,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  Table,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  FormLabel,
  FormControl,
  CircularProgress,
  TextField,
  Box,
  Tabs,
  Tab,
  Alert,
} from "@mui/material";
import DialogTitle from "@mui/material/DialogTitle";
import DeleteDialog from "../../helpers/DeleteDialog";
import moment from "moment";
import {
  categoryValues,
  getError,
  getFileMime,
  getSuccessMessage,
  inArray,
} from "../../store/helpers/common_functions";
import OpenDocument from "../../helpers/openDocument";
import { Add, CheckCircleOutlined } from "@material-ui/icons";
import { FormGroup } from "reactstrap";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { errorToast, successToast } from "../../helpers/Notification";
import { AttachEmail, NotificationAdd } from "@mui/icons-material";
import AddForm from "../../helpers/AddForm";
import a11yProps from "../../helpers/ay-props";
import TabPanel from "../../helpers/TabPanel";
import QuestionAnswers from "./QuestionAnswers";
import QtMaterialButton from "../../components/QtMaterialButton";

export const labels = [
  {
    label: "Pending",
    value: "pending",
  },
  {
    label: "Rejected",
    value: "rejected",
  },
  {
    label: "Submitted for vetting",
    value: "vetting-submitted",
  },
  {
    label: "Vetting Passed",
    value: "vetting-passed",
  },
  {
    label: "Vetting Failed",
    value: "vetting-failed",
  },
  {
    label: "Practical Passed",
    value: "practical-passed",
  },
  {
    label: "Practical Failed",
    value: "practical-failed",
  },
  {
    label: "Interview Passed",
    value: "interview-passed",
  },
  {
    label: "Interview Failed",
    value: "interview-failed",
  },
  {
    label: "Recruited",
    value: "recruited",
  },
  {
    label: "Candidate",
    value: "candidate",
  },
];

export function StatusBadge({ item, size }) {
  return (
    <Chip
      color={
        inArray(["rejected", "vetting-failed"], item)
          ? "error"
          : item === "recruited"
          ? "success"
          : inArray(["vetting-passed", "interview-passed"], item)
          ? "primary"
          : item === "interview-failed"
          ? "secondary"
          : undefined
      }
      label={labels.find((v) => v.value === item)?.label ?? item}
      size={size}
    />
  );
}

export function RecruitFormDialog({
  onSuccess,
  setOpen,
  open,
  id,
  value,
  setValue0,
  url,
  master,
}) {
  const disabled = !master;

  return (
    <FormDialog
      maxWidth={"md"}
      col={6}
      open={open > 0}
      onSuccess={onSuccess}
      setOpen={setOpen}
      url={
        url ??
        (open === 1 ? "/api/recruit/create" : `/api/recruit/update/${id}`)
      }
      title={open === 1 ? "New recruit" : "Edit recruit"}
      fields={[
        {
          name: "names",
          label: "First & Last name",
          value: value["names"],
          required: true,
          setValue: (val) => setValue0("names", val),
        },
        // {
        //     name: "category",
        //     label: "Category",
        //     type: "select",
        //     values: categoryValues,
        //     value: value['category'],
        //     required: true,
        //     disabled,
        //     setValue: (val) => setValue0('category', val),
        // },
        {
          name: "education",
          label: "Education",
          type: "select",
          values: [
            { label: "High School", value: "High School" },
            { label: "Bachelor", value: "Bachelor" },
            {
              label: "Masters",
              value: "Masters",
            },
            {
              label: "PhD",
              value: "PhD",
            },
          ],
          value: value["education"],
          required: true,
          setValue: (val) => setValue0("education", val),
        },
        {
          name: "email",
          label: "Email Address",
          type: "email",
          value: value["email"],
          required: true,
          setValue: (val) => setValue0("email", val),
        },
        {
          name: "phone",
          label: "Phone Number",
          type: "tel",
          value: value["phone"],
          required: true,
          setValue: (val) => setValue0("phone", val),
        },
        {
          name: "nationalId",
          label: "National ID/ Passport",
          value: value["nationalId"],
          minLength: 16,
          maxLength: 16,
          required: true,
          setValue: (val) => setValue0("nationalId", val),
        },
        {
          name: "nidAttachment",
          label: "National ID/ Passport Attachment",
          type: "file-drag",
          value: value["nidAttachment"],
          required: open === 1,
          setValue: (val) => setValue0("nidAttachment", val),
        },
        {
          name: "cv",
          label: "C.V (Attachment)",
          type: "file-drag",
          value: value["cv"],
          required: open === 1,
          setValue: (val) => setValue0("cv", val),
        },
        {
          name: "technology",
          label: "Other special skills or technologies",
          type: "textarea",
          col: 12,
          value: value["technology"],
          required: open === 1,
          setValue: (val) => setValue0("technology", val),
        },
      ]}
    />
  );
}

function RecruitManagement({
  location,
  loggedUser,
  technologies,
  GetTechnologies,
  rating,
  PutAction,
  fileName,
  FetchDetails,
  SubmitGeneralForm,
  systemSettings
}) {
  const mainBackground = systemSettings?.mainBackground;
  const [open, setOpen] = React.useState(0);
  const [openStatus, setOpenStatus] = React.useState(0);
  const [openAnswers, setOpenAnswers] = React.useState(0);
  const [openAttachLetter, setOpenAttachLetter] = useState(0);
  const [status, setStatus] = React.useState("");
  const [value, setValue] = React.useState({});
  const [list, setList] = React.useState([]);
  const [iRating, setRating] = useState(0);
  const [id, setId] = React.useState();
  const [deleteOpen, setDeleteOpen] = React.useState(false);
  const [savingRating, setSavingRating] = React.useState(false);
  const [count, setCount] = React.useState(0);
  const [info, setInfo] = React.useState(null);
  const [infoOpen, setInfoOpen] = React.useState(false);
  const [fileView, setFileView] = useState(null);
  const [positions, setPositions] = useState([]);
  const [schools, setSchools] = useState([]);
  const [approveData, setApproveData] = useState(null);
  const [showPractical, setShowPractical] = useState(false);
  const [showInterview, setShowInterview] = useState(false);
  const [preview, setPreview] = useState(null);
  const [finalLoading, setFinalLoading] = useState(false);
  const [addField, setAddField] = useState(false);
  const [tabValue, setTabValue] = React.useState(0);
  const [school, setSchool] = useState();

  const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };
  const className = `capitalize 'border-0' px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150`;

  const columns = [
    {
      name: "names",
      label: "Names",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "education",
      label: "Education",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "school",
      label: "Institution",
      options: {
        filter: true,
        sort: true,
        options: {
          filter: true,
          sort: true,
          customBodyRender: (v) => (
            <span style={{ textTransform: "capitalize" }}>{v}</span>
          ),
        },
      },
    },
    {
      name: "fieldName",
      label: "Field",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "positions",
      label: "Positions",
      options: {
        filter: true,
        sort: true,
      },
    },

    // {
    //     name: "email",
    //     label: "Email",
    //     options: {
    //         filter: true,
    //         sort: true,
    //     },
    // },
    // {
    //     name: "phone",
    //     label: "Phone",
    //     options: {
    //         filter: true,
    //         sort: true,
    //     },
    // },

    {
      name: "experience",
      label: "Experience(yrs)",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "cv",
      label: "CV",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (v) =>
          v ? (
            <Button
              variant={"outlined"}
              size={"small"}
              onClick={(e) => {
                e.stopPropagation();
                setFileView({ fileName: v });
              }}
            >
              View
            </Button>
          ) : null,
      },
    },
    {
      name: "status",
      label: "Status",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (item) => <StatusBadge item={item} />,
      },
    },
    {
      name: "createdAt",
      label: "Date",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (item) => moment(item).format("YYYY-MMM-DD"),
      },
    },
    {
      name: "id",
      label: "Action",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (v) => {
          const find = list?.find((vx) => vx.id === v);
          return (
            <BasicMenu
              extra={
                find?.status === "recruited"
                  ? undefined
                  : [
                      {
                        label: "Change Status",
                        onClick: () => {
                          setOpenStatus(1);
                          const obj = list.find((vx) => vx.id === v);
                          setValue0("status", obj.status);
                          setStatus(obj.status);
                          setId(v);
                        },
                      },
                      {
                        label: "Mark Question Answers",
                        icon: <NoteAltIcon />,
                        onClick: () => {
                          setOpenAnswers(1);
                          const obj = list.find((vx) => vx.id === v);
                          setValue0("status", obj.status);
                          setStatus(obj.status);
                          setId(v);
                        },
                      },
                      find?.status !== "interview-passed"
                        ? undefined
                        : {
                            label: "Attach Offer Letter",
                            icon: <AttachEmail />,
                            onClick: () => {
                              setOpenAttachLetter(1);
                              setId(v);
                            },
                          },
                    ]
              }
              onEdit={() => {
                setOpen(2);
                const obj = list.find((vx) => vx.id === v);
                setId(v);
                setValue0("names", obj.names);
                setValue0("category", obj.category);
                setValue0("email", obj.email);
                setValue0("phone", obj.phone);
                setValue0("nationalId", obj.nationalId);
                setValue0("technology", obj.technology);
                setValue0("experience", obj.experience);
                setValue0("education", obj.education);
              }}
              onDelete={() => {
                setDeleteOpen(true);
                setId(v);
              }}
            />
          );
        },
      },
    },
  ];

  const loadSchools = async () => {
    const resp = await FetchDetails(`/api/recruit/schools/list`);
    if (resp.status) {
      setSchools(
        resp.data.data?.map((item) => ({
          label: item.school,
          value: item.school,
        }))
      );
    }
  };
  const loadInfo = async () => {
    const resp = await FetchDetails(`/api/recruit/view/${id}`);
    if (resp.status) {
      setInfo(resp.data.data);
    }
  };
  const loadPositionQuestions = async () => {
    const resp = await FetchDetails(`/api/recruit/position/questions/${id}`);
    if (resp.status) {
      setPositions(resp.data.data);
    }
  };

  useEffect(() => {
    if (id) {
      loadInfo().then();
      loadPositionQuestions().then();
    }
  }, [id]);

  useEffect(() => {
    GetTechnologies();
    loadSchools().then();
  }, [GetTechnologies]);

  const recruited = value["status"] === "recruited";

  const setValue0 = (name, val) => {
    if (!name) {
      return null;
    }

    setValue((v) => {
      v[name] = val;
      return { ...v };
    });
  };

  const onSuccess = () => setCount((v) => v + 1);

  const RenderField = ({ name, label, type }) => {
    const getIt = () => {
      if (name.indexOf(".") > -1) {
        const names = name.split(".");
        let data = info;
        for (let k of names) {
          if (data) {
            data = data[k];
          }
        }
        return data;
      } else {
        return info[name];
      }
    };
    return info ? (
      <FormGroup className={"mb-3"} key={name}>
        <FormLabel>
          <Typography variant={"subtitle1"}>{label}</Typography>
        </FormLabel>
        <div>
          {type === "file" ? (
            <Button
              variant={"outlined"}
              onClick={() => setFileView({ ...info, fileName: getIt() })}
            >
              View Document
            </Button>
          ) : (
            getIt()
          )}
        </div>
      </FormGroup>
    ) : null;
  };

  const saveRating = async (newRating, ratingComment) => {
    setSavingRating(true);
    const resp = await PutAction(`/api/recruit/update/rating/${info?.id}`, {
      rating: newRating ?? iRating,
      ratingComment,
    });
    setSavingRating(false);
    if (resp.status) {
      onSuccess();
      successToast(getSuccessMessage(resp));
    } else {
      errorToast(getError(resp));
    }
  };

  const handleFieldClose = () => {
    setAddField(false);
  };

  return (
    <div className="w-full">
      <AddForm
        formAlert={
          "This offer letter will be sent to an applicant on his email"
        }
        open={openAttachLetter}
        title={"Upload Offer Letter"}
        setOpen={() => setOpenAttachLetter(0)}
        url={`/api/recruit/attach/letter/${id}`}
        mainFields={[
          {
            title: "",
            fields: [
              {
                name: "attachment",
                type: "file-drag",
                required: true,
              },
            ],
          },
        ]}
      />
      <Dialog
        open={openAnswers > 0}
        maxWidth={"lg"}
        fullWidth={true}
        onClose={() => setOpenAnswers(0)}
      >
        <DialogTitle>Answer Questions</DialogTitle>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
            value={tabValue}
            onChange={handleChange}
            aria-label="basic tabs example"
          >
            {positions.map((v, index) => (
              <Tab label={v.name} {...a11yProps(index)} />
            ))}
          </Tabs>
          {positions.map((v, index) => (
            <TabPanel index={index} value={tabValue} p={0}>
              <QuestionAnswers
                onClose={() => setOpenAnswers(0)}
                answers={v.answers}
                onSuccess={() => {
                  setOpenAnswers(0);
                  setId(null);
                  onSuccess();
                }}
                id={id}
                position={v}
              />
            </TabPanel>
          ))}
        </Box>
      </Dialog>
      {preview !== null && (
        <Dialog open={true} fullWidth={true} maxWidth={"md"}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <Tabs
              value={tabValue}
              onChange={handleChange}
              aria-label="basic tabs example"
            >
              {Object.keys(preview.preview).map((v, index) => (
                <Tab label={v} {...a11yProps(index)} />
              ))}
            </Tabs>
          </Box>
          <DialogContent>
            {Object.keys(preview.preview).map((v, index) => (
              <TabPanel index={index} value={tabValue} p={0}>
                <div
                  dangerouslySetInnerHTML={{ __html: preview.preview[v] }}
                ></div>
              </TabPanel>
            ))}
            <Alert severity={"warning"} className={"mt-2"}>
              This is a preview of the content and format of the emails to be
              sent
            </Alert>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setPreview(null)} color={"error"}>
              Close
            </Button>
            <QtMaterialButton
              onClick={async () => {
                setFinalLoading(true);
                const resp = await SubmitGeneralForm(
                  "/api/recruit/push/notifications",
                  { ...preview.form, preview: 0 }
                );
                if (resp.status) {
                  successToast(getSuccessMessage(resp));
                  setPreview(null);
                  setApproveData(null);
                } else {
                  errorToast(getError(resp));
                }
                setFinalLoading(false);
              }}
              loading={finalLoading}
              variant={"contained"}
            >
              Send Email
            </QtMaterialButton>
          </DialogActions>
        </Dialog>
      )}
      {approveData !== null && (
        <AddForm
          col={6}
          setOpen={(open, data, form) => {
            if (data?.list) {
              setPreview({ preview: data.list, form });
              return false;
            } else {
              setApproveData(null);
              return true;
            }
          }}
          open={true}
          title={"Send Notifications"}
          formAlert={""}
          url={"/api/recruit/push/notifications"}
          mainFields={[
            {
              title: "Practical Exam info",
              col: 6,
              hidden: !showPractical,
              fields: [
                {
                  name: "date",
                  label: "Exam Date",
                  type: "date",
                  required: true,
                },
                {
                  name: "venue",
                  label: "Venue",
                  required: true,
                },
              ],
            },
            {
              title: "Interview Exam info",
              col: 6,
              hidden: !showInterview,
              fields: [
                {
                  name: "oralDate",
                  label: "Exam Date",
                  type: "date",
                  required: true,
                },
                {
                  name: "oralVenue",
                  label: "Venue",
                  required: true,
                },
              ],
            },
            {
              title: "",
              fields: [
                {
                  name: "preview",
                  value: "1",
                  label: "Preview",
                  hidden: true,
                  required: true,
                  type: "hidden",
                },
                {
                  name: "applications",
                  value: approveData,
                  type: "json",
                  hidden: true,
                },
              ],
            },
          ]}
        />
      )}
      <DeleteDialog
        open={deleteOpen}
        setOpen={() => setDeleteOpen(false)}
        onSuccess={onSuccess}
        url={`/api/recruit/delete/${id}`}
      />
      <RecruitFormDialog
        master={loggedUser?.allowRecruit}
        onSuccess={onSuccess}
        setOpen={setOpen}
        open={open}
        id={id}
        setValue0={setValue0}
        value={value}
      />
      <FormDialog
        maxWidth={recruited ? "md" : "sm"}
        open={openStatus > 0}
        onSuccess={onSuccess}
        setOpen={setOpenStatus}
        url={`/api/recruit/change/status/${id}`}
        title={"Change Status"}
        fields={[
          {
            name: "status",
            label: "Status",
            type: "select",
            values: labels.filter(
              (v) =>
                v.value !== "recruited" ||
                (v.value === "recruited" && status === "interview-passed")
            ),
            value: value["status"],
            required: true,
            col: recruited ? 6 : 12,
            setValue: (val) => setValue0("status", val),
          },
          {
            name: "category",
            label: "Position",
            type: "select",
            values: categoryValues,
            value: value["category"],
            required: true,
            hidden: !recruited,
            col: 6,
            setValue: (val) => setValue0("category", val),
          },
          {
            name: "email",
            label: "QT Email Address",
            type: "email",
            value: value["email"],
            required: true,
            hidden: !recruited,
            col: 6,
            setValue: (val) => setValue0("email", val),
          },
          {
            name: "experience",
            label: "Experience (Overall)",
            type: "number",
            value: value["experience"],
            required: true,
            hidden: !recruited,
            col: 6,
            setValue: (val) => setValue0("experience", val),
          },
          {
            name: "entryDate",
            label: "Entry Date (QT)",
            type: "date",
            value: value["entryDate"],
            required: true,
            hidden: !recruited,
            col: 6,
            setValue: (val) => setValue0("entryDate", val),
          },
          {
            name: "dob",
            label: "Date of Birth (DOB)",
            type: "date",
            value: value["dob"],
            required: true,
            maxDate: moment(),
            hidden: !recruited,
            col: 6,
            setValue: (val) => setValue0("dob", val),
          },
          {
            name: "qtPin",
            label: "QT Connect PIN",
            type: "text",
            value: value["qtPin"],
            required: false,
            col: 6,
            hidden: !recruited,
            setValue: (val) => setValue0("qtPin", val),
          },
          {
            name: "technologies",
            label: "Technologies",
            type: "checkbox",
            col: 12,
            checkCol: 4,
            value: value["technologies"],
            hidden: !recruited,
            values: technologies?.map((v) => ({ value: v.id, label: v.name })),
            required: false,
            setValue: (val) => setValue0("technologies", val),
          },
          {
            name: "comment",
            label: "Comment",
            type: "textarea",
            value: value["comment"],
            required: value["status"] === "rejected",
            setValue: (val) => setValue0("comment", val),
          },
        ]}
      />

      <DatatableComponent
        selectableRows={true}
        showDatePicker={true}
        fileName={fileName}
        onRowClick={(data, { rowIndex }) => {
          setId(list[rowIndex].id);
          setInfoOpen(true);
          setRating(list[rowIndex].rating);
        }}
        addButton={
          <>
            <Button
              size={"small"}
              variant={"outlined"}
              onClick={() => {
                if (!approveData) {
                  successToast(
                    "Select/Check applications to send notifications to !"
                  );
                }
              }}
              startIcon={<NotificationAdd />}
            >
              Push Notifications
            </Button>
            <span className={"ml-2"}>
              <Button
                size={"small"}
                variant={"outlined"}
                onClick={() => setOpen(1)}
                startIcon={<Add />}
              >
                Add
              </Button>
            </span>
          </>
        }
        customToolbarSelect={(rows) => (
          <span className={"mr-2"}>
            <Button
              onClick={() => {
                const map = rows.data.map((v) => list[v.dataIndex]);
                setShowPractical(
                  map.filter(
                    (v) =>
                      v.status === "vetting-submitted" || v.status === "pending"
                  ).length > 0
                );
                setShowInterview(
                  map.filter((v) => v.status === "practical-passed").length > 0
                );
                setApproveData(map.map((v) => v.id));
              }}
              size={"small"}
              variant={"outlined"}
              startIcon={<NotificationAdd />}
            >
              Push Notifications
            </Button>
          </span>
        )}
        processData={(data) => {
          setList(data.data);
          return data;
        }}
        onRowSelectionChange={(list) => {}}
        elevation={0}
        pdf={true}
        excel={true}
        columns={columns}
        url={`/api/recruit/list?count=${count}&assigned=${
          location.state?.assigned ?? ""
        }&category=${location.state?.category ?? ""}${
          rating ? `&rating=${rating}` : ""
        }${school ? `&school=${school}` : ""}`}
        title={
          // rating === 2 ? 'Highly Recommended Recruits' : rating === 1 ? 'Recommended Recruits' : rating === -1 ? 'Not considered' :
          <div className="w-full">
            <Typography variant="h6">
              {
                <div
                  className="relative w-full"
                  style={{ marginTop: "10px", marginBottom: "10px" }}
                >
                  <select
                    style={{ textTransform: "capitalize" }}
                    placeholder={"schools"}
                    className={className}
                    value={school}
                    onChange={(e) => {
                      setSchool(e.target.value);
                    }}
                  >
                    <option value="">-- select --</option>
                    {schools?.map((item) => (
                      <option value={item.value}>{item.label}</option>
                    ))}
                  </select>
                </div>
              }
            </Typography>
          </div>
        }
      />
      <Dialog
        open={infoOpen}
        onClose={() => {
          setInfoOpen(false);
          setInfo(null);
        }}
        fullWidth={true}
        maxWidth={"md"}
      >
        {!info ? (
          <DialogContent>
            <div style={{ padding: "100px", textAlign: "center" }}>
              <CircularProgress />
            </div>
          </DialogContent>
        ) : (
          <>
            <DialogTitle>
              <div className={"flex"}>
                <div className={"flex-1"}>
                  Recruit Details{" "}
                  <Chip
                    label={labels.find((v) => v.value === info?.status)?.label}
                  />
                </div>
                <div style={{ minWidth: "300px" }} className={"text-end"}>
                  {savingRating ? (
                    <CircularProgress />
                  ) : (
                    <div>
                      <FormControl fullWidth={true} size={"small"}>
                        <InputLabel id="demo-simple-select-label">
                          Recruit Rating
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          value={iRating}
                          label="Rating"
                          onChange={(e) => {
                            setRating(e.target.value);
                            if (e.target.value !== 0) {
                              setAddField(true);
                            } else {
                              saveRating(e.target.value, "").then();
                            }
                          }}
                        >
                          <MenuItem value={0}>-- select --</MenuItem>
                          <MenuItem value={1}>Recommended</MenuItem>
                          <MenuItem value={2}>Highly Recommended</MenuItem>
                          <MenuItem value={-1}>Not Considered</MenuItem>
                        </Select>
                      </FormControl>
                      {!inArray([undefined, "", null], info?.ratingComment) && (
                        <div className={"mt-1"} style={{ fontSize: "12px" }}>
                          <b>Comment:</b> <span>{info.ratingComment}</span>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </DialogTitle>
            <DialogContent>
              <Card className={"mb-4"}>
                <CardHeader
                  title={`Personal Details`}
                  subheader={`Names, Address, tel, ID`}
                  titleTypographyProps={{ fontWeight: "bold" }}
                />
                <CardContent>
                  <div className={"flex flex-wrap"}>
                    <div className={"w-full md:w-4/12"}>
                      <RenderField
                        name={"names"}
                        label={"Full Names"}
                        required={true}
                      />
                    </div>
                    <div className={"w-full md:w-4/12"}>
                      <RenderField
                        type={"email"}
                        name={"email"}
                        label={"Email Address"}
                        placeholder={"Email"}
                        required={true}
                      />
                    </div>
                    <div className={"w-full md:w-4/12"}>
                      <RenderField
                        size={"small"}
                        type={"tel"}
                        label={"Phone Number"}
                        className={"form-control"}
                        placeholder={"Tel"}
                        name={"phone"}
                        required={true}
                      />
                    </div>
                  </div>
                  <div className={"flex flex-wrap"}>
                    <div className={"w-full md:w-4/12"}>
                      <RenderField
                        type={"number"}
                        label={"Nationality"}
                        name={"nationality"}
                      />
                    </div>
                    <div className={"w-full md:w-4/12"}>
                      <RenderField
                        type={"number"}
                        label={"National ID/Passport Number"}
                        name={"nationalId"}
                        required={true}
                        minLength={16}
                        maxLength={16}
                      />
                    </div>
                    <div className={"w-full md:w-4/12"}>
                      <RenderField
                        type={"file"}
                        label={"ID/Passport Copy"}
                        className={"form-control"}
                        placeholder={"NID"}
                        name={"nidAttachment"}
                        required={true}
                      />
                    </div>
                    {info?.offerLetter ? (
                      <div className={"w-full md:w-4/12"}>
                        <RenderField
                          type={"file"}
                          label={"Offer Letter"}
                          className={"form-control"}
                          placeholder={"Offer Letter"}
                          name={"offerLetter"}
                          required={true}
                        />
                      </div>
                    ) : null}
                  </div>
                </CardContent>
              </Card>
              <Card className={"mb-4"}>
                <CardHeader
                  title={<span>Preferred Job Position</span>}
                  titleTypographyProps={{ fontWeight: "bold" }}
                  subheader={`${
                    info?.RecruitPositions?.length ?? 0
                  } positions selected`}
                />
                <CardContent>
                  <div className={"flex flex-wrap"}>
                    {info?.RecruitPositions?.map((v) => (
                      <div className={"w-full md:w-4/12"}>
                        <Checkbox
                          checked={true}
                          type={"checkbox"}
                          id={v.id}
                          value={v.id}
                          name={"position"}
                        />
                        <label htmlFor={v.id} className={"ms-2 inline-block"}>
                          <Typography>{v.Position?.name}</Typography>
                        </label>
                      </div>
                    ))}
                  </div>
                </CardContent>
              </Card>
              <Card className={"mb-4"}>
                <CardHeader
                  title={`Academic Details`}
                  titleTypographyProps={{ fontWeight: "bold" }}
                  subheader={`C.V, Education, Special skills , etc ..`}
                />
                <CardContent>
                  <div className={"flex flex-wrap"}>
                    <div className={"w-full md:w-4/12"}>
                      <RenderField
                        type={"select"}
                        className={"form-control"}
                        label={"Level Of Education"}
                        name={"education"}
                      />
                    </div>
                    <div className={"w-full md:w-4/12"}>
                      <RenderField
                        style={{ textTransform: "capitalize" }}
                        type={"select"}
                        className={"form-control capitalize"}
                        label={"Institution Name"}
                        name={"school"}
                      />
                    </div>
                    <div className={"w-full md:w-4/12"}>
                      <RenderField
                        type={"select"}
                        className={"form-control"}
                        label={"Field of Study"}
                        name={"field.name"}
                      />
                    </div>
                    <div className={"w-full md:w-4/12"}>
                      <RenderField
                        label={"Curriculum vitae"}
                        type={"file"}
                        className={"form-control"}
                        name={"cv"}
                        required={true}
                      />
                    </div>
                  </div>
                  <div className={"flex flex-wrap"}>
                    <div className={"w-full md:w-12/12"}>
                      <RenderField
                        multiline={true}
                        label={"Other special skills or technologies"}
                        size={"small"}
                        className={"form-control"}
                        name={"technology"}
                        placeholder={"Type here ..."}
                      />
                    </div>
                  </div>
                </CardContent>
              </Card>
              <Card className={"mb-4"}>
                <CardHeader
                  title={<span>Submitted Documents</span>}
                  titleTypographyProps={{ fontWeight: "bold" }}
                  subheader={`${
                    info?.RecruitDocuments?.length ?? 0
                  } documents selected`}
                />
                <CardContent>
                  {info?.RecruitDocuments?.length > 0 && (
                    <>
                      <Table size={"small"}>
                        <TableHead>
                          <TableRow>
                            <TableCell
                              style={{ fontWeight: "bolder", fontSize: "17px" }}
                            >
                              Name
                            </TableCell>
                            <TableCell
                              style={{ fontWeight: "bolder", fontSize: "17px" }}
                            >
                              Document
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        {info.RecruitDocuments.map((v) => (
                          <TableRow>
                            <TableCell>{v.name}</TableCell>
                            <TableCell>
                              <Button
                                onClick={() => {
                                  setFileView({
                                    fileName: v.attachment,
                                  });
                                }}
                              >
                                View Document
                              </Button>
                            </TableCell>
                          </TableRow>
                        ))}
                      </Table>
                    </>
                  )}
                </CardContent>
              </Card>

              <Card className={"mb-4"}>
                <CardHeader
                  title={`Work Experience`}
                  titleTypographyProps={{ fontWeight: "bold" }}
                  subheader={`Years, Current Employee`}
                />
                <CardContent>
                  <div className={"flex flex-wrap"}>
                    <div className={"w-full md:w-4/12"}>
                      <RenderField
                        label={"Current Employer"}
                        className={"form-control"}
                        name={"employer"}
                      />
                    </div>
                    <div className={"w-full md:w-4/12"}>
                      <RenderField
                        className={"form-control"}
                        label={"Years of Experience"}
                        placeholder={"Experience"}
                        name={"experience"}
                      />
                    </div>
                  </div>
                </CardContent>
              </Card>

              {info?.RecruitComments?.length > 0 && (
                <Card className={"mb-4"}>
                  <CardHeader
                    title={`Change Status History`}
                    titleTypographyProps={{ fontWeight: "bold" }}
                  />
                  <CardContent>
                    <div className={"flex flex-wrap"}>
                      <div className={"w-full md:w-12/12"}>
                        {info?.RecruitComments?.map((v) => (
                          <div className={"mb-3 border-b pb-3"}>
                            <div>
                              <StatusBadge item={v.status} size={"small"} />
                            </div>
                            <div>{v.comment}</div>
                            <div style={{ fontSize: "13px" }}>
                              <b>By :</b> {v.User?.firstName} {v.User?.lastName}
                            </div>
                            <div
                              className={"mb-3"}
                              style={{ fontSize: "11px" }}
                            >
                              {moment(v).format("YYYY-MM-DD HH:mm")}
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </CardContent>
                </Card>
              )}
            </DialogContent>
            <DialogActions>
              {info?.status !== "recruited" && (
                <Button
                  startIcon={<CheckCircleOutlined />}
                  onClick={() => {
                    setOpenStatus(1);
                    const obj = list.find((vx) => vx.id === info?.id);
                    setValue0("status", obj.status);
                    setInfo(null);
                    setId(info?.id);
                  }}
                >
                  Change Status
                </Button>
              )}
            </DialogActions>
          </>
        )}
      </Dialog>
      <Dialog
        open={addField}
        onClose={handleFieldClose}
        maxWidth={"xs"}
        fullWidth={true}
      >
        <form
          onSubmit={(e) => {
            e.preventDefault();
            const data = new FormData(e.currentTarget);
            const value = data.get("comment");
            saveRating(iRating, value).then();
            setAddField(false);
          }}
        >
          <DialogTitle>Add Comment</DialogTitle>
          <DialogContent>
            <TextField
              size={"small"}
              name={"comment"}
              rows={3}
              multiline={true}
              required={true}
              placeholder={"Add Comment"}
              fullWidth={true}
            />
          </DialogContent>

          <DialogActions>
            <Button color="error" onClick={handleFieldClose}>
              Cancel
            </Button>{" "}
            <Button
              type={"submit"}
              style={{ backgroundColor: mainBackground}}
              variant={"contained"}
            >
              Add
            </Button>
          </DialogActions>
        </form>
      </Dialog>
      <Dialog
        maxWidth={"md"}
        fullWidth={true}
        open={fileView !== null}
        onClose={() => setFileView(null)}
      >
        <DialogContent>
          {fileView !== null && (
            <OpenDocument
              downloadable={true}
              document={fileView?.fileName}
              name={"supportDocument"}
              specialName={fileView?.fileName}
              type={"permission-doc"}
              mimeType={getFileMime(fileView?.fileName)}
            />
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(RecruitManagement);
